<template>
  <google-map :center="{lat: center[0], lng: center[1]}" :zoom="zoom" :options="options">
    <google-info-window :options="infoWindow.options" :position="infoWindow.position" :opened="infoWindow.open" @closeclick="infoWindow.open=false">
      <div class="text-center pt-4 pb-4 px-3">
        <p class="xsmall font-weight-heavy" v-html="infoWindow.content.title"></p>
        <p class="xxxsmall" v-html="infoWindow.content.descr"></p>
      </div> 
    </google-info-window>

    <gmap-cluster :styles="clusterStyles" :zoom-on-click="true" :max-zoom="3">
      <google-marker v-for="marker in compMarkers" :key="marker.id" :icon="marker.icon.url" :position="{lat: marker.position[0], lng: marker.position[1]}" @click="toggleInfoWindow({lat: marker.position[0], lng: marker.position[1]},{title: marker.title, descr: marker.descr},marker.id)">
      </google-marker>
    </gmap-cluster>
  </google-map>
</template>

<script>
  import * as VueGoogleMaps from 'vue2-google-maps/dist/vue-google-maps.js'
  import gmapCluster from 'vue2-google-maps/dist/components/cluster'

  Vue.use(VueGoogleMaps, {
    load: {
      key: process.env.NODE_ENV === 'development' ? process.env.MIX_MAP_KEY_LOCAL : process.env.MIX_MAP_KEY,
    },
    installComponents: false,
  })

  import mapStyles from './styles.json'

  export default {
    components: {
      gmapCluster,
      googleMap: VueGoogleMaps.Map,
      googleMarker: VueGoogleMaps.Marker,
      googleInfoWindow: VueGoogleMaps.InfoWindow
    },
    props: {
      center: {
        type: Array,
        required: false,
        default: () => [37.992566, 23.767961]
      },
      zoom: {
        type: Number,
        required: false,
        default: 17
      },
      markers: {
        type: Array,
        required: false,
        default: () => [{
          id: "1",
          position: [37.992566, 23.767961],
          title: `<p class='mb-2'><b>Freshdesign</b></p>`,
          descr: `<p class='lh-15'>Sevastoupoleos 113, <br> Ampelokipoi <br> Athens</p>`
        }]
      }
    },
    computed: {
      compMarkers() {
        this.markers.forEach((value) => {
          if (!value.icon) {
            value.icon = {
              url: `/public/site/${process.env.MIX_TEMPLATE_FOLDER}/dist/images/pin.png`,
              // size: {width: 46, height: 46, f: 'px', b: 'px'},
              scaledSize: {
                width: 15,
                height: 15,
                f: 'px',
                b: 'px'
              }
            }
          }
        });

        return this.markers
      }
    },
    data() {
      return {
        options: {
          styles: mapStyles,
          // gestureHandling: "greedy",
          scrollwheel: false,
          streetViewControl: false,
          mapTypeControl: false,
          zoomControl: true,
          fullscreenControl: false
        },
        infoWindow: {
          open: false,
          options: {
            pixelOffset: {
              width: 0,
              height: -15
            }
          },
          content: {
            title: `<p class='mb-2'><b>Freshdesign</b></p>`,
            descr: `<p class='lh-15'>Sevastoupoleos 113, <br> Ampelokipoi <br> Athens</p>`,
            tel: '<p>+30 210 62000 18</p>'
          },
          position: null
        },
        clusterStyles: [{
          textColor: '#fff',
          url: `/public/site/${process.env.MIX_TEMPLATE_FOLDER}/dist/images/cluster.png`,
          height: 50,
          width: 50
        }],
        currentMidx: null
      }
    },
    methods: {
      toggleInfoWindow: function (position, content, idx) {
        this.infoWindow.position = position;
        this.infoWindow.content = content;

        //check if its the same marker that was selected if yes toggle
        if (this.currentMidx == idx) {
          this.infoWindow.open = !this.infoWindow.open;
        }

        //if different marker set infowindow to open and reset current marker index
        else {
          this.infoWindow.open = true;
          this.currentMidx = idx;
        }
      }
    },
  }
</script>

<style scoped lang="scss">
  .gm-style {
    p {
      color: #000;
    }
  }
</style>